import { useQuery } from '@tanstack/react-query';
import type { AiVisibilityReportUsageResponse } from '@brand24-original/llm-types';
import { getAiVisibilityUsage } from '../../services/ai-visibility-report/AiVisibilityReportService';
import { GET_AI_VISIBILITY_USAGE } from '../../query/ai-visibility-report/keys';

/**
 * Monthly quota for the whole account — no projectId in the key, so switching projects reuses
 * the same cache entry. Invalidated by generate (usage grows) and by run delete (a cancelled or
 * dismissed run gives its slot back).
 */
export const useGetAiVisibilityUsage = (enabled: boolean) =>
  useQuery<AiVisibilityReportUsageResponse>({
    queryKey: [GET_AI_VISIBILITY_USAGE],
    queryFn: getAiVisibilityUsage,
    enabled,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
